<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div v-if="data" class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4 class="modal-title">
						Asociar contrato
					</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="btn-toolbar pull-right" role="toolbar">
								<div class="btn-group" role="group" aria-label="...">
									<input @keyup="doFilter()" v-model="datatable.moreParams.filter.text" type="text" class="form-control" placeholder="Buscar...">
								</div>

								<div class="btn-group" role="group" aria-label="...">
									<button
										title="Filtrar"
										ref="btnfilter"
										@click="doFilter()"
										:disabled="!datatable.moreParams.filter.text"
										data-style="slide-left"
										class="btn btn-success">
										<i class="fa fa-search" aria-hidden="true"></i>
									</button>
									<button
										title="Restablecer"
										ref="btnreset"
										@click="reset()"
										data-style="slide-left"
										class="btn btn-default">
										<i class="fa fa-refresh" aria-hidden="true"></i>
									</button>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<loading :active="datatable.loading">
								<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
							</loading>

							<div class="table-responsive">
								<datatable
									ref="datatable"
									:append-params="datatable.moreParams"
									:http-options="datatable.options"
									:css="datatable.css.table"
									:api-url="datatable.api"
									:fields="datatable.fields"
									:per-page="datatable.page"
									:pagination-path="datatable.path"
									:sort-order="datatable.sortOrder"
									@vuetable:loading="tableLoading"
									@vuetable:loaded="loaded">

									<template slot="id" slot-scope="props">
										<router-link
											:to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/agreements/' + props.rowData.id + '/edit'">
											{{ props.rowData.id }}
										</router-link>
									</template>

									<template slot="title" slot-scope="props">
										<router-link
										:to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/agreements/' + props.rowData.id">
											{{ props.rowData.title }}
										</router-link>
									</template>

									<template slot="start" slot-scope="props">
										<template v-if="props.rowData.start">
											{{ props.rowData.start | moment(false) }}
										</template>
									</template>

									<template slot="end" slot-scope="props">
										<template v-if="props.rowData.end">
											{{ props.rowData.end | moment(false) }}
										</template>
									</template>

									<template slot="interval" slot-scope="props">
										<template v-if="props.rowData.interval">
											{{ props.rowData.interval.name }}
										</template>
									</template>

									<template slot="status" slot-scope="props">
										<template v-if="props.rowData.status">
											<template v-if="props.rowData.status.lang">
												{{ props.rowData.status.lang.name }}
											</template>
											<template v-else>
												{{ staprops.rowData.statustus.name }}
											</template>
										</template>
									</template>

									<template slot="buttons" slot-scope="props">
										<button @click="add(props.rowData)":id="'btn-add-agreement-' + props.rowData.id" class="btn btn-success">
											<i class="fa fa-plus" aria-hidden="true"></i>
										</button>
									</template>
								</datatable>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VueElementLoading from 'vue-element-loading'
	import _ from 'lodash'

	export default {
		props: ['user', 'isAuth', 'data'],
		components: {
			'datatable': Vuetable,
			'loading': VueElementLoading,
		},
		created() {
			if(this.data.customer_id) {
				this.datatable.moreParams.filter.customer_id = this.data.customer_id
			}
		},
		data () {
			return {
				modal: {
					selector: 'modal-add-customer'
				},
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/agreements/datatable',
					loading: true,
					moreParams: {
						filter: {
							customer_id: null,
							text: null,
						}
					},
					page: 20,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							title: this.$platform.setting.number_symbol,
							name: 'id',
						},
						{
							title: 'Título',
							name: 'title',
						},
						{
							title: 'Inicio',
							name: '__slot:start',
						},
						{
							title: 'Fin',
							name: '__slot:end',
						},
						{
							title: 'Intervalo',
							name: '__slot:interval',
						},
						{
							title: 'Estado',
							name: '__slot:status',
						},
						{
							name: 'created_at',
							title: 'Fecha',
							sortField: 'created_at',
							callback: function(value) {
								return moment(value).format('DD/MM/YY H:mm')
							},
						},
						{
							name: '__slot:buttons',
						},
					],
				},
			}
		},
		mounted() {
			var that = this
			var modal = $('#'+this.modal.selector)
			modal.on("hidden.bs.modal", function() {
				that.reset()
			})
		},
		methods: {
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			doFilter: _.debounce(function () {
				this.$nextTick( () => this.$refs.datatable.refresh())
			}, 300),
			reset() {
				this.datatable.moreParams.filter.text = null
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loaded() {
				this.datatable.loading = false
			},
			tableLoading() {
				this.datatable.loading = true
			},
			add(agreement) {
				var loading = Ladda.create(document.querySelector('#btn-add-agreement-' + agreement.id))
				loading.start()
				var data = {
					agreement_id: agreement.id
				}
				this.$http.put('admin/management/invoices/' + this.data.id, data)
				.then(response => {
					loading.stop()
					this.$emit('reload')
					this.close()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					loading.stop()
				})
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/views/AddAgreement.vue